// @flow

import * as React from 'react';

import styles from './styles.scss';
import { sailAnimation, fadeInRight, animateMenuItems, preloader } from '../../utils/animation';
import Content from './Content';

class Categories extends React.Component<{}> {
  componentDidMount() {
    if (document && document.body) {
      document.body.classList.add('services');
    }

    const callback = () => {
      if (window.innerWidth > 768) {
        animateMenuItems().play();
        fadeInRight('[data-animation="top"]').delay(0.1);
        fadeInRight('[data-animation="bottom"]').delay(0.3);
        sailAnimation().play();
      }
    };

    preloader(callback).play();
  }

  componentWillUnmount() {
    if (document && document.body) {
      document.body.classList.remove('services');
    }
  }

  render() {
    return (
      <div className={styles['page-wrapper']}>
        <div className="page-cover" data-clear />
        <Content />
      </div>
    );
  }
}

export default Categories;



// WEBPACK FOOTER //
// ./src/pages/Categories/index.js